/* eslint-disable @typescript-eslint/no-empty-function */
import {
  Box,
  Grid,
  Popover,
  Skeleton,
  Typography,
  Theme,
  useTheme,
} from '@mui/material';
import { SxProps } from '@mui/system';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { getAssetAllocation, getAumDistributionChart, getCastHistory, getCustomerCount, getTeamAccountsData, TeamAccountsType } from '../../redux-store/actions/userManagement';
import { RootStateType } from '../../redux-store/reducers';
import {
  AumChart,
  GetCashHistory,
  GetCustomerCount,
  NewRmDashBoardType,
  RmDashBoardGraph,
  filterType,
} from '../../redux-store/types/api-types';
import { CommonLayout, PopoverValue } from '../commonComponents';
import {  fetchTeamAccountOptions, formatCurrency, formatToIndianCurrency, maskInfo } from '../../utils/utilityFunctions';
import {
  AccountsIcon,
  CashAvailableIcon,
  TotalAUMIcon,
  TotalHoldingsIcon,
} from '../customSVGs';
import CustomePieChart from './chart/CustomePieChart';
import { ErrorText } from './chart/CustomeLineChart';
import Account from './table/Account';
import { filteringAum } from '../../utils/filtering';
import useAumTableHook from '../CustomeHook/useAumTableHook';
import moment from 'moment';
import CardChart from './chart/CardChart';
import HierachicalTable from './table/HierachicalTable';
import { Order, PaginationObj, SortingObj } from '../investorOverview/types';
import { whiteSpaceOnlyRegex } from '../../utils/regex';
import { useRefDebounce } from '../../utils/useDebounce';
import { useRoleStack } from '../../hooks/useRoleStack';
import BreadCrum from '../../lib/BreadCrum';
import CustomBarChart from './chart/CustomBarComponent';
import CustomDropdown from '../investorOverview/directEquity/directEquityOverview/CustomDropdown';
import FormikCustomDropdown from '../../lib/formik/CustomDropdown';



export const scrollbarView = {
  '::-webkit-scrollbar': {
    width: '16px',
    background: 'white',
  },
  '::-webkit-scrollbar-thumb': {
    background: '#4990F0',
    borderRadius: '10px',
    width: '16px',
    boxShadow: 'none',
  },
  '::-webkit-scrollbar-track': {
    background: '#D6E7FE',
    borderRadius: '10px',
    borderRight: '7px solid transparent',
    borderLeft: '7px solid transparent',
    backgroundClip: 'padding-box',
    width: '2px',
  },
};
export function InfoCard({
  label,
  value,
  onClick,
  isLoading,
  sx,
  color = '#1473CC',
  icon,
  chartData
}: {
  label: string | undefined;
  value: string | number;
  color?: string;
  onClick?: () => void;
  isLoading?: boolean;
  sx?: SxProps;
  icon?: JSX.Element | React.ReactNode;
  chartData?: Array<any>
}): JSX.Element {

  return (
    <Box
      sx={(theme: Theme) => ({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        columnGap: '1rem',
        padding: { xs: '20px 12px', sm: '14px 14px', md: '16px 16px', lg: "18px 16px", xl: '20px 16px' },
        boxShadow: '0px 4px 10px rgb(0 0 0 / 5%)',
        borderRadius: '20px',
        background: theme.palette.common.white,
        [theme.breakpoints.up(1550)]: {
          padding: '25px 18px'
        }
      })}>
      {/* <Link
        onClick={onClick}
        sx={{
          pointerEvents: isLoading ? 'none' : 'unset',
          cursor: onClick ? 'pointer' : 'unset',
          color: '#fff',
          display: 'block',
          textDecoration: 'none',
          padding: { sm: '15px 18px', md: '20px 18px', lg: "25px 18px" },
          background: '#FFFFFF',
          // borderColor: color,
          boxShadow: '0px 4px 10px rgb(0 0 0 / 5%)',
          borderRadius: '20px',
          ...sx,
          // '&:hover,&:focus': {
          //   boxShadow: onClick ? '0px 2px 10px rgb(0 0 0 / 20%)' : '0px 2px 10px rgb(0 0 0 / 8%)',
          // },
        }}> */}
      <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '1rem', }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          {icon}
        </Box>
        <Box >
          <Typography
            variant='body_500'
            sx={(theme: Theme) => (
              {
                mb: '10px',
                mt: '-5px',
                width: isLoading ? '90px' : 'unset',
                color: 'text.primary',
                // fontSize: ['16px', '14px', '14px', '14px', '14px'],
                // fontWeight: 500,
                // lineHeight: '14px',
                // [theme.breakpoints.up(1550)]: {
                //   fontSize: '16px'
                // }
              }
            )}>
            {isLoading ? <Skeleton /> : label}
          </Typography>
          <Typography
            variant='body_700'
            sx={(theme: Theme) => (
              {
                width: isLoading ? '100px' : 'unset',
                color: 'text.primary',
                // fontSize: ['20px', '15px', '16px', '16px', '16px'],
                // fontWeight: 600,
                // lineHeight: '14px',
                // [theme.breakpoints.up(1550)]: {
                //   fontSize: '20px'
                // }
              }
            )}>
            {isLoading ? <Skeleton /> : value}
          </Typography>
        </Box>
        {/* <GraphSvg /> */}
      </Box>
      {chartData &&
        <CardChart data={chartData?.map(item => [(item?.month || item?.week), item?.lastData])} />
      }

      {/* </Link > */}
    </Box >
  );
}

function ValuePopOver({
  valueType,
  percent: percentProp,
  value,
  assetName,
  popoverContent,
  color = '#67ADF1',
  gainlossPercent = 0,
}: {
  valueType: string;
  percent: number;
  value: number;
  assetName: string;
  popoverContent?: JSX.Element | React.ReactNode;
  color?: string;
  gainlossPercent?: number;
}) {
  const positiveGainLossPercent = Math.abs(gainlossPercent);
  const [percent, setPercent] = useState(0);
  useEffect(() => {
    if (percentProp > 0) {
      setTimeout(() => setPercent(percentProp), 0);
    }
  }, [percentProp]);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  return (
    <>
      <Box
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        sx={{
          display: 'flex',
          justifyContent: valueType === 'invested' ? 'flex-end' : 'flex-start',
          width: '100%',
          position: 'relative',
          pr: valueType === 'invested' ? 2.5 : 0,
          pl: valueType === 'invested' ? 0 : 2.5,
          '&::after': {
            content: '""',
            width: '7px',
            height: '7px',
            borderRadius: '50%',
            background: color,
            position: 'absolute',
            right: valueType === 'invested' ? 0 : 'unset',
            left: valueType === 'invested' ? 'unset' : 0,
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 1,
          },
          '&::before': {
            content: '""',
            width: '20px',
            height: '1px',
            borderBottom: '1px dashed',
            borderColor: color,
            position: 'absolute',
            right: valueType === 'invested' ? 0 : 'unset',
            left: valueType === 'invested' ? 'unset' : 0,
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 1,
          },
        }}>
        <Box
          sx={{
            fontSize: 11,
            fontWeight: 500,
            color: '#fff',
            px: 1.2,
            py: 0.6,
            position: 'relative',
            width: `${percent}%`,
            transition: 'width 0.5s ease',
            borderRadius: valueType === 'invested' ? ' 20px 0px 0px 20px' : '0px 20px 20px 0px',
            cursor: 'pointer',
          }}>
          <Box
            sx={{
              borderRadius: 'inherit',
              position: 'absolute',
              left: 0,
              top: 0,
              bottom: 0,
              right: 0,
              overflow: 'hidden',
            }}>
            <Box
              sx={{
                position: 'absolute',
                width: `${positiveGainLossPercent
                  ? percent < 10
                    ? 100 - positiveGainLossPercent - percent
                    : percent < 50 &&
                      percent / positiveGainLossPercent < 4 &&
                      percent / positiveGainLossPercent > 2
                      ? 100 + positiveGainLossPercent - percent
                      : 100 - positiveGainLossPercent
                  : 100
                  }%`,
                background: color,
                top: 0,
                bottom: 0,
                left: 0,
                zIndex: 1,
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                width: '100%',
                borderRadius: 'inherit',
                backgroundColor: gainlossPercent < 0 ? '#E89292' : '#8ED8B7',
                top: 0,
                left: 0,
                bottom: 0,
                zIndex: 0,
              }}></Box>
          </Box>

          <span
            style={{
              position: 'absolute',
              color: percent < 10 ? '#22242C' : 'inherit',
              right:
                valueType === 'invested'
                  ? percent < 10
                    ? `${100 - (percent - 10)}%`
                    : 0
                  : 'unset',
              left:
                valueType === 'invested' ? 'unset' : percent < 10 ? `${100 - (percent - 10)}%` : 0,
              zIndex: 2,
            }}>
            {percent}%
          </span>
          <span style={{ visibility: 'hidden' }}>0</span>
        </Box>
      </Box>
      <Popover
        id="mouse-over-popover"
        sx={{
          pointerEvents: 'none',
          left: valueType === 'invested' ? -20 : 20,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: valueType === 'invested' ? 'right' : 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: valueType === 'invested' ? 'left' : 'right',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus>
        {popoverContent ? (
          popoverContent
        ) : (
          <Box sx={{ p: 1 }}>
            <PopoverValue label={assetName} color={color} amount={value} percent={percent} />
          </Box>
        )}
      </Popover>
    </>
  );
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function AssetAllocationCard({
  label,
  onClickLabel = () => { },
  investedPercent,
  currentPercent,
  investedValue,
  currentValue,
  xirr,
  isLoading,
  link,
  labelStyles,
  leftPopoverContent,
  rightPopoverContent,
  leftBarColor,
  rightBarColor,
}: {
  label: string;
  onClickLabel?(): void;
  investedPercent: number | string;
  currentPercent: number | string;
  investedValue: number | string;
  currentValue: number | string;
  xirr?: number | null;
  isLoading?: boolean;
  link?: string;
  labelStyles?: SxProps;
  leftPopoverContent?: JSX.Element | React.ReactNode;
  rightPopoverContent?: JSX.Element | React.ReactNode;
  leftBarColor?: string;
  rightBarColor?: string;
}) {
  const history = useHistory();
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', mb: 3.5 }}>
      <Box style={{ width: '50%', textAlign: 'right' }}>
        {isLoading ? (
          <Skeleton />
        ) : (
          <ValuePopOver
            popoverContent={leftPopoverContent}
            color={leftBarColor ? leftBarColor : '#67ADF1'}
            valueType="invested"
            percent={Number(investedPercent)}
            value={Number(investedValue)}
            assetName={label}
          />
        )}
      </Box>
      <Box style={{ width: 150, textAlign: 'center' }}>
        {isLoading ? (
          <Skeleton sx={{ width: 80, margin: 'auto' }} />
        ) : (
          <Typography
            sx={{
              fontSize: { md: 12, lg: 14 },
              lineHeight: '16px',
              color: '#22242C',
              opacity: 0.8,
              padding: '5px 12px',
              // border: '1px solid #0BAAE7',
              borderRadius: '5px',
              // width: 150,
              whiteSpace: 'nowrap',
              margin: 'auto',
              ...labelStyles,
            }}
            onClick={onClickLabel}>
            {label}
          </Typography>
        )}
      </Box>
      <Box style={{ width: '50%' }}>
        {isLoading ? (
          <Skeleton />
        ) : (
          <ValuePopOver
            popoverContent={rightPopoverContent}
            gainlossPercent={xirr !== null ? xirr : undefined}
            color={rightBarColor ? rightBarColor : '#8ED8B7'}
            valueType="current"
            percent={Number(currentPercent)}
            value={Number(currentValue)}
            assetName={label}
          />
        )}
      </Box>
    </Box>
  );
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function RevenuePercent({
  label,
  percent: percentProp,
  amount,
  color,
  isLoading,
  popOverAmt,
  sx,
}: {
  label: string;
  percent: number;
  amount: string;
  color: string;
  isLoading: boolean;
  popOverAmt?: number;
  sx?: SxProps;
}) {
  const [percent, setPercent] = useState(0);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setTimeout((_) => setPercent(percentProp), 0);
  }, [percentProp]);
  const open = Boolean(anchorEl);
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        pb: 3.75,
        ...sx,
      }}>
      {isLoading ? (
        <Skeleton sx={{ width: 150 }} />
      ) : (
        <Typography
          className="left"
          sx={{
            fontSize: 13,
            lineHeight: '15px',
            fontWeight: 400,
            color: '#1E346B',
            opacity: 0.8,
            textAlign: 'right',
            width: 150,
            mr: 4,
          }}>
          {label}
        </Typography>
      )}
      <Box
        className="progress-bar"
        onMouseEnter={popOverAmt ? handlePopoverOpen : () => { }}
        onMouseLeave={handlePopoverClose}
        sx={{
          flexGrow: 1,
          position: 'relative',
          overflowX: 'hidden',
          zIndex: 9,
          '&::after': {
            content: '" "',
            position: 'absolute',
            left: 0,
            top: '50%',
            transform: 'translateY(-50%)',
            width: '100%',
            height: '1px',
            borderBottom: '2px dashed rgba(0,0,0,0.1)',
            zIndex: 1,
          },
        }}>
        {isLoading ? (
          <Skeleton sx={{ width: '90%', margin: 'auto' }} />
        ) : (
          <Box
            aria-owns={open ? 'mouse-over-popover' : undefined}
            aria-haspopup="true"
            sx={{
              background: color,
              width: `100%`,
              transform: `translateX(-${100 - percent}%)`,
              transition: 'transform 0.5s ease',
              borderRadius: '0px 20px 20px 0px',
              cursor: 'pointer',
              height: 14,
              position: 'relative',
              zIndex: 2,
            }}></Box>
        )}
        <Popover
          id="progress-bar-popover"
          sx={{
            pointerEvents: 'none',
            left: 0,
          }}
          PaperProps={{
            sx: {
              background: '#FFFFFF',
              boxShadow: '0px 4px 40px 4px rgba(0, 0, 0, 0.07)',
              borderRadius: '3px',
              padding: '10px',
            },
          }}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          onClose={handlePopoverClose}
          disableRestoreFocus>
          <PopoverValue
            label={label}
            amount={popOverAmt ? formatToIndianCurrency(popOverAmt) : 'NA'}
            color={color}
            percent={percent}
          />
        </Popover>
      </Box>
      {isLoading ? (
        <Skeleton sx={{ width: 50 }} />
      ) : (
        <Typography
          className="right"
          sx={{
            fontSize: 13,
            fontWeight: 400,
            color: '#101010',
            opacity: 0.8,
            width: 80,
            ml: 3.5,
          }}>
          {amount || 'NA'}
        </Typography>
      )}
    </Box>
  );
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function ProgressBarIntervals({ sx }: { sx?: SxProps }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, ...sx }}>
      <Typography className="left" sx={{ width: 150, mr: 4 }}></Typography>
      <Box
        className="progress-bar"
        sx={{ flexGrow: 1, display: 'flex', justifyContent: 'space-between' }}>
        {[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map((item, index) => (
          <Typography
            key={index}
            sx={{
              fontSize: 12,
              fontWeight: 400,
              color: '#22242C',
              opacity: 0.4,
              lineHeight: '14px',
            }}>
            {item}
          </Typography>
        ))}
      </Box>
      <Typography className="right" sx={{ width: 80, ml: 3.75 }}></Typography>
    </Box>
  );
}

export default function Dashboard(): JSX.Element {
  const history = useHistory();
  const { palette, typography } = useTheme()


  const [isLoading, setLoading] = useState(true);
  const [aumDistLoading, setAumDistLoading] = useState<boolean>(false);
  const [assetLoading, setAssetLoading] = useState(true)

  const [selectedAssetsType, setSelectedAssetsType] = useState<'product' | 'assetClass'>('product');
  const { role = '', subRole = "", roles = [] } = useSelector((store: RootStateType) => store.auth);
  const id = useSelector((store: RootStateType) => store.id);
  const valueConverter = useSelector((state: any) => state.valueConverter);
  const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);
  const [dashBoardMetricsData, setDashBoardMetricsData] = useState<NewRmDashBoardType>({} as NewRmDashBoardType);
  const [dashBoardGraphData, setDashBoardGraphData] = useState<RmDashBoardGraph>({});
  const [flip, setFlip] = useState(false);
  const [filterValue, setFilterValue] = useState<string | number>(1);
  const [assetFilter, setassetFilter] = useState<string | number>(1)
  const [aumData, setAumData] = useState<{ aum: { family: any; individual: any }, filterOption: filterType[] }>({} as { aum: { family: any; individual: any }, filterOption: filterType[] });
  const [accountTable, setAccountTable] = useState<any>([]);
  const [cards, setCard] = useState<Array<GetCashHistory>>([]);
  const [exportData, setExportData] = useState<any>([])
  const [teamAccountsData, setTeamAccountsData] = useState<any>([])

  //error status
  const [aumDistributionError, setAumDistributionError] = useState(false);
  const [castHistoryError, setCastHistoryError] = useState(false);
  const [assetAllocationError, setAssetAllocationError] = useState(false)
  const [pieChartError, setpieChartError] = useState(false)

  const [cardFilter, setCardFilter] = useState<string | number>(1);
  const [assetAllocation, setAssetAllocation] = useState<any>([])
  const [customerCountData, setCustomerCountData] = useState<GetCustomerCount>({} as GetCustomerCount)
  const { getCurrentRoleName, getCurrentStack } = useRoleStack();
  const [teamAccountsLoading, setTeamAccountsLoading] = useState<boolean>(false);
  const [aumTeamAccData, setAumTeamAccData] = useState<any>([]);
  const [teamAccountValue, setTeamAccountValue] = useState<string>('');
  const [aumTeamAcctDropdown, setAumTeamAcctDropdown] = useState<any>(teamAccountValue);

  const investorAccountOptions = [
    {
      label: "Direct Investor",
      value: 'Y'
    },
    {
      label: "Indirect Investor",
      value: 'N'
    }
  ]


  const [invAccountTab, setInvAccountTab] = useState<string>('Y');

  const handleOuterTabChange = async (event: React.SyntheticEvent, newValue: string) => {
    setInvAccountTab(newValue);

    try {
      setLoading(true);
      const aumDistributionRes = await (dispatch(getAumDistributionChart({ rmId: rmId, mappingType: curRole === "IFA" ? "" : curRole === "BRANCH" ? "" : newValue, ...(curRole === "BRANCH" ? { branch: curRoleName?.id } : {}) })) as unknown as Promise<any>);
      if (aumDistributionRes?.isSuccess) {
        setAumDistributionError(false);
        const modifiedRes = {
          ...aumDistributionRes, result: aumDistributionRes?.result?.map((ele: any) => ({
            ...ele,
            customerName: maskInfo(ele?.customerName),
          })) ?? []
        }
        setExportData(modifiedRes?.result as any);
        setAccountTable(getAumTable(modifiedRes?.result as Array<AumChart>))

        const modifiedRes2 = {
          ...aumDistributionRes, result: aumDistributionRes?.result?.map((ele: any) => ({
            ...ele,
            customerName: maskInfo(ele?.customerName),
            familyName: maskInfo(ele?.familyName)
          }))
        }
        setAumData(filteringAum(modifiedRes2?.result as Array<AumChart>) as any);
      }
      else {
        setAumData({
          aum: {
            family: {
              name: [], value: []
            }, individual: {
              name: [], value: []
            }
          }, filterOption: []
        })
        setAumDistributionError(true)
      }
    } catch (e) {
      console.error('Error', e);
    } finally {
      setLoading(false);
    }
  }
  const stack = getCurrentStack();
  const curRole = stack.length > 0 ? stack[stack.length - 1]?.role : subRole;
  const curRoleName = getCurrentRoleName();

  const [hierachicalOptions, setHierachyOptions] = useState<any>([]);
  const [ifaAumType, setIfaAumType] = useState<string | number>(1); // 1 = Individual, 2 = Family


  const dispatch = useDispatch();
  const { getAumTable } = useAumTableHook()
  const componentRef = React.useRef<HTMLDivElement>(null);
  const debounce = useRefDebounce();

  const rmId = curRole === "BRANCH" ? id.iwappRmId : stack.length > 0 ? stack[stack.length - 1].id : id.iwappRmId;

  const { pushRole } = useRoleStack();
  const handleRoleChange = (name: string, id: string) => {
    const hierachicalOptions = fetchTeamAccountOptions(teamAccountValue ?? "");
    pushRole(teamAccountValue, name, id, hierachicalOptions, hierachicalOptions?.[0]?.value);
    setTeamAccountValue(hierachicalOptions?.[0]?.value);
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])


  const getTeamAccounts = async ({
    rmId = id.iwappRmId,
    category = teamAccountValue,
    rowsPerPage = 10,
    currentPage = 1,
    search = "",
    order = "desc",
    orderBy = "netAssets",
    apiFrom = ''
  }: {
    rmId?: string | number,
    category?: string,
    rowsPerPage?: number,
    currentPage?: number,
    search?: string,
    order?: string,
    orderBy?: string,
    apiFrom?: string
  } = {}) => {
    try {
      if (!category) return;
      setTeamAccountsLoading(true);
      if (apiFrom !== 'teamAccounts') {
        setAumDistLoading(true);
      }
      const teamAccountsRes = await dispatch(getTeamAccountsData({ rmId, category, rowsPerPage, currentPage, search, order, orderBy, ...(curRole === "BRANCH" ? { branch: curRoleName?.id } : {}), }) as unknown as Promise<TeamAccountsType>)
      if (teamAccountsRes?.isSuccess) {
        setTeamAccountsData(teamAccountsRes?.result ?? []);
        setTablePaginationObj(prevState => ({
          ...prevState,
          totalRows: teamAccountsRes?.total
        }))
        const top5Accounts = teamAccountsRes?.result?.slice(0, 5);
        const aumTeamAccCategories = top5Accounts?.map((ele: any) => ele?.categoryName);
        const aumTeamAccValues = top5Accounts?.map((ele: any) => ele?.netAssets);
        const totalMarketValue = top5Accounts?.reduce((acc: any, ele: any) => acc + ele?.netAssets, 0);
        const bookPercentage = top5Accounts?.map((ele: any) => ele?.capitalPercent);
        if (apiFrom !== 'teamAccounts') {
          setAumTeamAccData({
            data: top5Accounts,
            aumTeamAccCategories,
            aumTeamAccValues,
            totalMarketValue,
            bookPercentage
          });
        }
      }
    } catch (e) {
      console.error('Error', e);
    } finally {
      setTeamAccountsLoading(false);
      if (apiFrom !== 'teamAccounts') {
        setAumDistLoading(false);
      }
    }
  }

  useEffect(() => {
    let isComponentActive = true;
    setDashBoardMetricsData({} as NewRmDashBoardType);
    (async function () {
      if (id.iwappRmId) {
        try {
          setLoading(true);
          setAssetLoading(true);
          try {
            const [res2, res3, res4, res5]: any = await Promise.all([
              dispatch(getAumDistributionChart({ rmId: rmId, mappingType: curRole === "IFA" ? "" : curRole === "BRANCH" ? "" : invAccountTab, ...(curRole === "BRANCH" ? { branch: curRoleName?.id } : {}) })) as unknown | Array<AumChart>,
              dispatch(getCastHistory({ rmId: rmId, ...(curRole === "BRANCH" ? { branch: curRoleName?.id } : {}) })) as unknown | Array<GetCashHistory>,
              dispatch(getCustomerCount({ rmId: rmId, ...(curRole === "BRANCH" ? { branch: curRoleName?.id } : {}) })) as unknown | Array<GetCashHistory>,
            ]);

            if (res2?.isSuccess) {
              setAumDistributionError(false);
              const modifiedRes = {
                ...res2, result: res2?.result?.map((ele: any) => ({
                  ...ele,
                  customerName: maskInfo(ele?.customerName),
                })) ?? []
              }
              setExportData(modifiedRes?.result as any);
              setAccountTable(getAumTable(modifiedRes?.result as Array<AumChart>))

              const modifiedRes2 = {
                ...res2, result: res2?.result?.map((ele: any) => ({
                  ...ele,
                  customerName: maskInfo(ele?.customerName),
                  familyName: maskInfo(ele?.familyName)
                }))
              }
              setAumData(filteringAum(modifiedRes2?.result as Array<AumChart>) as any);
            }
            else {
              setAumData({
                aum: {
                  family: {
                    name: [], value: []
                  }, individual: {
                    name: [], value: []
                  }
                }, filterOption: []
              })
              setAumDistributionError(true)
            }

            if (res3?.isSuccess) {
              setCard(res3?.result as Array<GetCashHistory>);
            } else {
              setCastHistoryError(true)
            }

            if (res4?.isSuccess) {
              setCustomerCountData(res4 as GetCustomerCount);
            }
            else {
              setCustomerCountData({} as GetCustomerCount);
            }
            if (res5?.isSuccess) {
              setTeamAccountsData(res5)
            }

          } catch (e) {
            console.log("error", e)
            setAssetAllocationError(true)
            setAumDistributionError(true)
            setCastHistoryError(true)
          }
          if (!isComponentActive) {
            return;
          }
          setAssetLoading(false);
          setLoading(false);
        } catch (e) {
          setAssetLoading(false);
          setLoading(false);
          console.log((e as Error).message);
        }
      }
    })();
    return () => {
      isComponentActive = false;
    };
  }, [id.iwappRmId, stack.length]);

  useEffect(() => {

    const fetch = async () => {
      try {
        setAssetLoading(true);
        const res4: any = (await dispatch(getAssetAllocation({ category: assetFilter === 1 ? "Asset Group" : "Asset Class", rmId: rmId, ...(curRole === "BRANCH" ? { branch: curRoleName?.id } : {}) }))) as unknown | Array<AumChart>;
        if (res4?.isSuccess) {
          setAssetAllocation({ ...res4?.result, result: { ...res4?.result } })
        }
        else {
          setAssetAllocation({
            data: [],
          })
        }
      } catch (e) {
        console.log("error", e)
        setAssetAllocation({
          data: [],
        })
        // setpieChartError(true)
      } finally {
        setAssetLoading(false);
      }
    }

    if (id.iwappRmId && assetFilter) fetch()
  }, [assetFilter, id.iwappRmId, stack.length])

  useEffect(() => {
    if (stack.length > 0) {
      setHierachyOptions(stack[stack.length - 1].hierachyOptions);
      setTeamAccountValue(stack[stack.length - 1].defaultOption);
      setAumTeamAcctDropdown(stack[stack.length - 1].defaultOption);
      getTeamAccounts({ rmId: rmId, category: stack[stack.length - 1]?.hierachyOptions?.[0]?.value });
    }
    else {
      const hierachyOptions = fetchTeamAccountOptions(subRole ?? "");
      setHierachyOptions(hierachyOptions);
      setTeamAccountValue(hierachyOptions?.[0]?.value);
      setAumTeamAcctDropdown(hierachyOptions?.[0]?.value);
      if (id.iwappRmId)
        getTeamAccounts({ category: hierachyOptions?.[0]?.value });
    }
  }, [id.iwappRmId, curRole])


  const momentDates = [...cards].map(obj => moment(obj.navDate, 'YYYYMMDD'));

  // Find the index of the latest date
  const latestIndex = momentDates.reduce((acc, curr, index) => (curr.isAfter(momentDates[acc]) ? index : acc), 0);

  // Get the object with the latest date
  const latestObject = cards[latestIndex];

  const [searchText, setSearchText] = useState<string>('');

  const [tableSortingObj, setTableSortingObj] = useState<SortingObj>({
    order: "desc",
    orderBy: "netAssets"
  })
  const [tablePaginationObj, setTablePaginationObj] = useState<PaginationObj>({
    currentPage: 0,
    rowsPerPage: 10,
    totalRows: 0
  })
  const handleSort = (orderBy: string, order: Order) => {
    setTableSortingObj({
      order,
      orderBy
    })
    getTeamAccounts({ rmId: rmId, rowsPerPage: tablePaginationObj.rowsPerPage, currentPage: tablePaginationObj.currentPage + 1, orderBy, order, apiFrom: 'teamAccounts' })
  }

  const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTablePaginationObj(prevState => ({
      ...prevState,
      rowsPerPage: Number(event.target.value),
      currentPage: 0,
    }))
    getTeamAccounts({ rmId: rmId, rowsPerPage: Number(event.target.value), orderBy: tableSortingObj.orderBy, order: tableSortingObj.order, apiFrom: 'teamAccounts' })
  }

  const handlePageChange = (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => {
    setTablePaginationObj(prevState => ({
      ...prevState,
      currentPage: page
    }))
    getTeamAccounts({ rmId: rmId, rowsPerPage: tablePaginationObj.rowsPerPage, currentPage: page + 1, orderBy: tableSortingObj.orderBy, order: tableSortingObj.order, apiFrom: 'teamAccounts' })
  }

  const handleSearchTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (whiteSpaceOnlyRegex.test(event.target.value)) return;
    setSearchText(event.target.value);
    debounce(() => getTeamAccounts({ rmId: rmId, search: event.target.value, apiFrom: 'teamAccounts' }))
  }

  const handleClearSearch = (e: React.MouseEvent<HTMLButtonElement>) => {
    setSearchText("")
    e.preventDefault();
    getTeamAccounts({ rmId: rmId, search: "", apiFrom: 'teamAccounts' })
  }

  const currentRoleAndName = getCurrentRoleName();
  const handleHierachyDropdown = (value: string) => {
    setTeamAccountValue(value);
    setSearchText('');
    getTeamAccounts({ rmId: rmId, orderBy: tableSortingObj.orderBy, order: tableSortingObj.order, rowsPerPage: tablePaginationObj.rowsPerPage, currentPage: tablePaginationObj.currentPage + 1, category: value, apiFrom: 'teamAccounts' });
  }

  const getAumDistributionData = async (category: string) => {
    try {
      setAumDistLoading(true);

      const res = await dispatch(getTeamAccountsData({ rmId, category, rowsPerPage: 10, currentPage: 1, search: "", order: "desc", orderBy: "netAssets", ...(curRole === "BRANCH" ? { branch: curRoleName?.id } : {}) })) as unknown as TeamAccountsType;

      if (res?.isSuccess) {
        const top5 = res.result?.slice(0, 5);

        setAumTeamAccData({
          data: top5,
          aumTeamAccCategories: top5?.map(e => e.categoryName),
          aumTeamAccValues: top5?.map(e => e.netAssets),
          totalMarketValue: top5?.reduce((acc, e) => Number(acc + e.netAssets), 0),
          bookPercentage: top5?.map(e => e.capitalPercent),
        });
      }
    } finally {
      setAumDistLoading(false);
    }
  };

  const handleAumAccountValueChange = (value: string | number) => {
    setAumTeamAcctDropdown(value);
    getAumDistributionData(`${value}`);
  }

  const getIfaChartData = () => {
    if (!aumData?.aum) return { categories: [], values: [], bookPercentage: [], ids: [] };

    const isIndividual = ifaAumType === 1;

    const source = isIndividual
      ? aumData.aum.individual
      : aumData.aum.family;

    const values: number[] = source?.value || [];
    const aumAmount = Number(latestObject?.netAssets) || 0;

    const bookPercentage = values.map((val: number) =>
      aumAmount ? Number(((Number(val) / aumAmount) * 100).toFixed(2)) : 0
    );

    return {
      categories: source?.name || [],
      values,
      bookPercentage,
      ids: source?.ids || [],
    };
  };



  return (
    <div ref={componentRef}>
      <CommonLayout>
        <>
          <BreadCrum array={[]} dynamic={true} />
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.9rem' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }} >
              <Typography sx={{ color: 'text.primary' }} variant='h1'>
                {currentRoleAndName?.role ? `Dashboard (${currentRoleAndName.name})` : `Welcome Back, ${roles?.[0]?.firstName}`}
              </Typography>
              {/* {curRole === "BRANCH" && (
                <CustomDropdown
                  options={[
                    {
                      label: "Jammu",
                      value: 'Jammu'
                    },
                    {
                      label: "Chennai",
                      value: 'Chennai'
                    },
                    {
                      label: "Delhi",
                      value: 'Delhi'
                    },
                    {
                      label: "Kolkata",
                      value: 'Kolkata'
                    },
                    {
                      label: "Mumbai",
                      value: 'Mumbai'
                    },
                    {
                      label: "Pune",
                      value: 'Pune'
                    },
                    {
                      label: "Hyderabad",
                      value: 'Hyderabad'
                    },
                    {
                      label: "Bangalore",
                      value: 'Bangalore'
                    },
                  ]}
                  defaultValue={''}
                  IsLoading={false}
                  searchable={true}
                />
              )} */}
            </Box>
          </Box>
          <Grid container columnSpacing={2} rowSpacing={2} sx={{ mb: '25px', flexWrap: 'wrap' }}>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <InfoCard
                isLoading={isLoading}
                label={'AUM Thriveiti'}
                value={latestObject?.nonhHldwyAum < 0 ? `- ${formatCurrency({ value: Math.abs(latestObject?.nonhHldwyAum ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: latestObject?.nonhHldwyAum ?? 0, locale, currencyCode })}` || "-"}
                icon={
                  <TotalAUMIcon />
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <InfoCard
                isLoading={isLoading}
                label={'AUM External'}
                value={latestObject?.heldAwayAUM < 0 ? `- ${formatCurrency({ value: Math.abs(latestObject?.heldAwayAUM ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: latestObject?.heldAwayAUM ?? 0, locale, currencyCode })}` || "-"}
                icon={<CashAvailableIcon />}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <InfoCard
                isLoading={isLoading}
                label={'Clients Onboarded'}
                value={customerCountData?.response?.[0].CustomerCount || "-"}
                icon={<AccountsIcon />}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <InfoCard
                isLoading={isLoading}
                label={'Clients Transacted'}
                value={customerCountData?.response?.[0].HldCustomerCount || "-"}
                icon={
                  <TotalHoldingsIcon />
                }
              />
            </Grid>
          </Grid>

          <Grid container columnSpacing={3} rowSpacing={3}>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <Box sx={(theme: Theme) => ({
                width: '100%',
                padding: { xs: "15px 20px 35px 20px", sm: '25px 30px 45px 30px' },
                borderRadius: '20px',
                background: theme.palette.common.white,
                boxShadow: '0px 4px 10px 0px #0000000D',
                height: '100%',
              })} >
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: { xs: "baseline" } }}>
                  <Typography variant='h2' sx={{
                    fontWeight: 600,
                    fontSize: 20,
                  }}>Asset Allocation

                  </Typography>
                  <FormikCustomDropdown setFilterValue={setassetFilter} IsLoading={assetLoading} options={[
                    {
                      "label": "By Product",
                      "value": 1
                    },
                    {
                      "label": "By Asset Class",
                      "value": 2
                    }
                  ]} defaultValue={1} />
                </Box>

                <Box sx={{
                  height: "100%",
                  display: 'flex',
                  alignItems: "center"
                }}>

                  {(assetLoading || assetAllocation?.data?.length !== 0) ? <CustomePieChart
                    key={assetFilter + "_" + JSON.stringify(assetAllocation?.data)}
                    {...{ ...assetAllocation, isLoading: assetLoading, showSlider: true, title: 'Asset Allocation' }} /> : (!assetLoading && assetAllocation?.data?.length === 0 && <ErrorText />)}
                </Box>
              </Box>
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <Box sx={(theme: Theme) => ({
                width: '100%',
                borderRadius: '20px',
                background: theme.palette.common.white,
                boxShadow: '0px 4px 10px 0px #0000000D',
                height: '100%'
              })}>
                <CustomBarChart
                  title="AUM Distribution"
                  data={
                    curRole === "IFA"
                      ? getIfaChartData()
                      : {
                        categories: aumTeamAccData?.aumTeamAccCategories,
                        values: aumTeamAccData?.aumTeamAccValues,
                        bookPercentage: aumTeamAccData?.bookPercentage
                      }
                  }
                  isLoading={isLoading || aumDistLoading}
                  isError={false}
                  isEmpty={
                    curRole === "IFA"
                      ? !getIfaChartData().values.length
                      : aumTeamAccData?.data?.length === 0
                  }
                  totalValue={aumTeamAccData?.totalValue ?? 1}
                  formatValue={(v) => formatCurrency({ value: v, locale, currencyCode })}
                  tooltipDescription="AUM Distribution of top 5 selected category"
                  rightComponent={
                    curRole === "IFA" ? (
                      <CustomDropdown
                        isLoading={false}
                        selectedValue={ifaAumType}
                        dropdownOptions={aumData?.filterOption || []}
                        handleValueChange={(val) => setIfaAumType(val)}
                      />
                    ) : (
                      <CustomDropdown
                        isLoading={isLoading || aumDistLoading}
                        selectedValue={aumTeamAcctDropdown}
                        dropdownOptions={hierachicalOptions}
                        handleValueChange={handleAumAccountValueChange}
                      />
                    )
                  }
                />

              </Box>
            </Grid>
          </Grid>

          {/* Hierachical Table */}
          {curRole !== "IFA" && (
            <HierachicalTable
              isLoading={teamAccountsLoading}
              tableData={teamAccountsData}
              handleSort={handleSort}
              tableSortingObj={tableSortingObj}
              handleRowsPerPageChange={handleRowsPerPageChange}
              handlePageChange={handlePageChange}
              tablePaginationObj={tablePaginationObj}
              handleClearSearch={handleClearSearch}
              searchText={searchText}
              handleSearchTextChange={handleSearchTextChange}
              hierachyOptions={hierachicalOptions}
              handleHierachyDropdown={handleHierachyDropdown}
              selectedValue={teamAccountValue}
              handleRoleChange={handleRoleChange}
            />
          )}

          {/* Investor Accounts */}
          <Account {...{ isLoading: isLoading, accountTable, aumAmount: latestObject?.netAssets, error: aumDistributionError, exportData, investorAccountOptions, invAccountTab, handleOuterTabChange }} />
        </>
      </CommonLayout>
    </div>
  );
}
